module.exports = __webpack_public_path__ + "img/panamerican.bd24f50a.jpg";